require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/babel-polyfill/~/core-js/modules/es6.array.species.js
// module id = 670
// module chunks = 0